import { formatDate } from "src/utils/string/stringUtil";
import { TQC2070_R01Filter } from "./Store_TQC2070_R01";

/**
 * 기본 분석일자 생성 함수
 * @param filter - TQC2070_R01Filter (searchAnalysisDt 포함)
 * @returns yyyy-MM-dd 형식의 날짜 문자열
 */
export const buildDefaultAnalysisDt = (filter?: TQC2070_R01Filter | null): string => {
	if (!filter?.searchAnalysisDt) {
		return formatDate(new Date());
	}

	// searchAnalysisDt 형식: yyyy-MM
	const parts = filter.searchAnalysisDt.split('-');
	if (parts.length !== 2) {
		// 잘못된 형식인 경우 오늘 날짜 반환
		return formatDate(new Date());
	}

	const [year, month] = parts;
	// 해당 월의 첫 번째 날짜 반환 (yyyy-MM-dd 형식)
	return `${year}-${month}-01`;
};

/**
 * valueIndex 정규화 함수
 * - 유효한 양수면 그대로 반환
 * - 그렇지 않으면 fallbackIndex 반환
 * @param valueIndex - 원본 valueIndex
 * @param fallbackIndex - 대체 값 (보통 배열 인덱스 + 1)
 * @returns 정규화된 valueIndex
 * @example
 * normalizeValueIndex(5, 1) // 5 (유효한 값)
 * normalizeValueIndex(0, 1) // 1 (0은 무효, fallback 사용)
 * normalizeValueIndex(null, 3) // 3 (null은 무효, fallback 사용)
 */
export const normalizeValueIndex = (
	valueIndex: number | undefined | null,
	fallbackIndex: number
): number => {
	return (valueIndex && valueIndex > 0) 
		? Number(valueIndex) 
		: fallbackIndex;
};

/**
 * analysisDt에서 일자만 추출하는 함수
 * @param analysisDt - yyyy-MM-dd 형식의 날짜 문자열
 * @returns 일자 (dd 형식) 또는 빈 문자열
 * @example
 * extractDayFromAnalysisDt('2024-01-15') // '15'
 * extractDayFromAnalysisDt('2024-12-05') // '05'
 * extractDayFromAnalysisDt('invalid') // ''
 */
export const extractDayFromAnalysisDt = (analysisDt: string): string => {
	if (!analysisDt) return '';
	const parts = analysisDt.split('-');
	return parts.length === 3 ? parts[2] : '';
};

